import React, { FC } from 'react';
import { APIS } from '../../../lib/constants/apis';
import FoerderAntragRightSidebar from './right-side-bar/FoerderAntragRightSidebar';
import VerwendungsnachweisRichtSidebar from './right-side-bar/VerwendungsnachweisRichtSidebar';

const AntragRightSideBar: FC<{ api: string }> = ({ api }) => {
	const RenderSidebar = () => {
		if (api === APIS.Antrag) {
			return <FoerderAntragRightSidebar />;
		}
		if (api === APIS.Verwendungsnachweis) {
			return <VerwendungsnachweisRichtSidebar />;
		}
		return <></>;
	};

	return <RenderSidebar />;
};

export default AntragRightSideBar;
